import React from 'react'
import { Link } from 'react-router-dom'

// Shared attorney-portal chrome: wordmark, the split auth shell, and the
// signed-in app header. Keeps Signup / Login / Portal visually cohesive with
// the marketing landing.

export function Wordmark({ light = false, to = '/' }) {
  return (
    <Link to={to} className="flex items-center gap-3">
      <img src="/attorney/LeaseCheck%20Logo%20resized.png" alt="" width="581" height="572" className="h-[68px] w-auto" />
      <span className={`text-2xl font-bold tracking-tight ${light ? 'text-white' : 'text-emerald-600'}`}>LeaseCheck</span>
      <span className="hidden rounded-full bg-emerald-100 px-2.5 py-0.5 text-xs font-semibold text-emerald-800 sm:inline-block">for Lawyers</span>
    </Link>
  )
}

// Two-column auth layout: branded pitch panel (desktop) + form card.
export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen font-sans lg:grid-cols-2">
      {/* Brand panel — desktop only */}
      <div className="relative hidden overflow-hidden bg-slate-950 lg:block">
        <img src="/attorney/hero-review.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950/80 via-emerald-950/70 to-teal-950/80" />
        <div className="relative flex h-full flex-col justify-between p-12">
          <Wordmark light />
          <div>
            <h2 className="max-w-md text-3xl font-bold leading-tight tracking-tight text-white">
              Get in front of Colorado renters the moment they need counsel.
            </h2>
            <p className="mt-4 max-w-md text-emerald-100/80">
              Warm, intent-driven lease referrals — straight to your inbox. List your practice in minutes.
            </p>
          </div>
          <p className="text-sm text-emerald-200/70">© 2026 LeaseCheck · Colorado landlord-tenant law</p>
        </div>
      </div>

      {/* Form side */}
      <div className="flex flex-col bg-slate-50">
        <div className="flex items-center justify-between px-6 py-5 lg:hidden">
          <Wordmark />
        </div>
        <div className="flex flex-1 items-center justify-center px-6 py-10">
          <div className="w-full max-w-md">
            <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-slate-600">{subtitle}</p>}
            <div className="mt-8">{children}</div>
            {footer && <div className="mt-6 text-center text-sm text-slate-600">{footer}</div>}
          </div>
        </div>
      </div>
    </div>
  )
}

// Signed-in top bar.
export function AppHeader({ status, onSignOut }) {
  const chip = {
    active: ['Live', 'bg-emerald-100 text-emerald-700'],
    draft: ['Draft', 'bg-amber-100 text-amber-700'],
    pending: ['Pending', 'bg-amber-100 text-amber-700'],
    rejected: ['Not verified', 'bg-red-100 text-red-700'],
    suspended: ['Suspended', 'bg-red-100 text-red-700'],
  }[status] || ['Draft', 'bg-amber-100 text-amber-700']
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-3.5">
        <Wordmark to="/" />
        <div className="flex items-center gap-4">
          <span className={`rounded-full px-3 py-1 text-xs font-semibold ${chip[1]}`}>{chip[0]}</span>
          <button onClick={onSignOut} className="text-sm font-semibold text-slate-600 transition hover:text-slate-900">
            Sign out
          </button>
        </div>
      </div>
    </header>
  )
}

export const field =
  'mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-slate-900 shadow-sm transition focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200'
